var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createClient } from 'contentful';
import { useEffect, useState } from 'react';
const client = createClient({
    space: 'lnhrh9gqejzl',
    accessToken: 'lMYX1QYf8ftyQy1vP8v5Teyx7qZd2XQXCs1INuAYnhk',
});
export const useMastheadData = (locale, contentfulEntryId) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetch = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield client.withoutUnresolvableLinks.getEntries({
                    'sys.id[in]': [contentfulEntryId],
                    include: 6,
                    locale,
                });
                setData(response.items[0]);
            }
            catch (e) {
                setError(`${JSON.stringify(e)}`);
            }
        });
        fetch();
    }, [contentfulEntryId, locale]);
    return { data, error };
};
//# sourceMappingURL=useMastheadData.js.map